import { render } from "./ChartGrip.vue?vue&type=template&id=2d2ced14&scoped=true"
import script from "./ChartGrip.vue?vue&type=script&lang=js"
export * from "./ChartGrip.vue?vue&type=script&lang=js"

import "./ChartGrip.vue?vue&type=style&index=0&id=2d2ced14&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-nps\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2ced14"]])

export default __exports__